import { topicsData } from '@/mocks/home-data';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热门话题
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8">
          当前最受关注的热门八卦话题，看看大家都在讨论什么
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="group bg-background-100 rounded-lg p-4 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-200"
            >
              <div className="flex items-start justify-between mb-2">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                  {topic.name}
                </h3>
                {topic.trend === 'hot' && (
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-[10px] text-accent-500">
                    <i className="ri-fire-fill"></i>
                  </span>
                )}
                {topic.trend === 'new' && (
                  <span className="flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                    NEW
                  </span>
                )}
              </div>
              <div className="flex items-center gap-2 text-xs">
                <span className="text-primary-500 font-medium">{topic.heat}</span>
                <span className="text-foreground-400">热度</span>
                {topic.trend === 'up' && (
                  <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}